import type { TISAUser } from '@/types/tisa-coins';
import { getBankAccountSummaries } from '@/lib/tisa-helpers';

interface Props {
  user: TISAUser;
  onRefresh: () => void;
}

export function BankSection({ user }: Props) {
  const accounts = getBankAccountSummaries(user.coin_events);

  return (
    <div className="bg-gray-900/50 border-2 border-gold/30 rounded-xl p-6">
      <h2 className="text-xl font-cinzel font-bold text-gold mb-4">
        🏦 Bank Accounts
      </h2>
      <div className="space-y-3">
        {accounts.map(account => (
          <div key={account.account_type} className="bg-black/30 border border-gold/20 rounded-lg p-3">
            <div className="flex justify-between items-center mb-2">
              <p className="font-poppins font-bold text-white text-sm">{account.account_type === 'vault' ? 'Vault' : `Savings ${(account.interest_rate * 100).toFixed(0)}%`}</p>
              <p className="text-gold font-orbitron font-bold">{account.balance}</p>
            </div>
            {account.locked && (
              <p className="text-xs text-gray-400">🔒 Locked - {account.lock_period}</p>
            )}
            {!account.locked && account.balance > 0 && (
              <button className="w-full mt-2 px-3 py-1 bg-gold/20 text-gold rounded text-xs font-bold hover:bg-gold/30">
                Withdraw
              </button>
            )}
          </div>
        ))}
        <button className="w-full px-4 py-2 bg-gold text-black rounded-lg font-bold hover:bg-gold/80">
          + Deposit Coins
        </button>
      </div>
    </div>
  );
}
